<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="selectedTab.emit($event.index)">
  <mat-tab label="PROFILE">
    <app-account-mgmt-profile [account]="account"></app-account-mgmt-profile>
  </mat-tab>
  <mat-tab label="BILLING">
    <app-billing-tab [account]="account"></app-billing-tab>
  </mat-tab>
  <mat-tab label="PROPERTIES">
    <app-properties-tab [account]="account"></app-properties-tab>
  </mat-tab>
  <mat-tab label="BANKING">
    <app-account-banking-tab [account]="account"></app-account-banking-tab>
  </mat-tab>
  <mat-tab label="RECEIPTS">
    <app-account-receipts-tab [account]="account"></app-account-receipts-tab>
  </mat-tab>
  <mat-tab label="NOTES">
    <!-- Lazy so it reloads on open: notes added on a return showed only after a page reload. -->
    <ng-template matTabContent>
      <app-account-notes-tab [account]="account"></app-account-notes-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="RETURNS">
    <ng-template matTabContent>
      <app-account-returns-tab [account]="account"></app-account-returns-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="ATTACHMENTS">
    <app-account-attachments-tab [account]="account"></app-account-attachments-tab>
  </mat-tab>
  <mat-tab label="HISTORY">
    <app-account-history-tab [account]="account"></app-account-history-tab>
  </mat-tab>
</mat-tab-group>
